import BaseApi from '@/api/Base/BaseApi'
import { FileProcessingTaskType, GetFilePreprocessingListResponse } from '@/api/FileProcessing/types'

const ROOT = '/file-processing-task'

export default class FileProcessingApi extends BaseApi {
  getFileProcessingTaskStatus(fpJobId: string) {
    return this.agent.get<FileProcessingTaskType>(`${ROOT}/${fpJobId}`)
  }

  cancelFileProcessingTask(fpJobId: string) {
    return this.agent.put<FileProcessingTaskType>(`${ROOT}/${fpJobId}/cancel`)
  }

  getFileProcessingTaskList(projectId: string) {
    return this.agent.get<GetFilePreprocessingListResponse>(`${ROOT}/${projectId}/list`)
  }

  downloadFileProcessingTask(fpJobId: string) {
    return this.agent.put(`${ROOT}/${fpJobId}/download`, {}, {
      responseType: 'blob',
    })
  }
}
